import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './../../service/auth/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  forgotpasswordForm: FormGroup;
  isSubmitted  =  false;
  isValid=false;
  loader:boolean=true;
  constructor(private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    private toastr:ToastrService,
    
    private http:HttpClient) { 
      if (this.service.currentUserValue) { 
        this.router.navigate(['/praking-fee']);
      }
    }

  ngOnInit(): void {
   
     
      this.forgotpasswordForm = this.formBuilder.group({
        email: ['', Validators.required],
      });
  
  }
  get formControls() { return this.forgotpasswordForm.controls; }
  forgetPassword(){
    this.isSubmitted = true;
    this.isValid = true;
    this.loader = true;
    // console.log(this.forgotpasswordForm);
    if (this.forgotpasswordForm.valid) {
      this.service.forgotpassword(this.forgotpasswordForm.value).subscribe((res:any)=>{
        this.loader = false;
        if (res.status == true) {
          this.router.navigate(['wgiacm']);
          this.toastr.success(res.message);
        } else {
          this.toastr.success(res.message);
          this.isSubmitted = false;
          this.loader=false;
        }
      });
      }
    
   }
}
